module.exports = __webpack_public_path__ + "static/media/bg-01.fcb7b252.jpg";